import eleven from '../images/covers/singles/11-9-16.jpg'
import chosenFew from '../images/covers/singles/chosen-few.jpeg'
import ctm from '../images/covers/singles/ctm.jpeg'
import fightingGravity from '../images/covers/singles/fighting-gravity.jpg'
import glow from '../images/covers/singles/glow.jpg'
import hardwoodClassic from '../images/covers/singles/hardwood-classic.jpeg'
import pointOfView from '../images/covers/singles/point-of-view.png'
import theseFeelings from '../images/covers/singles/these-feelings.jpg'

export const singleRoutes = [
    {
        title: "Celebrate These Moments",
        img: ctm,
        spotify: "",
        apple: "",
        soundcloud: "https://soundcloud.com/spinyoungplanet/celebrate-these-moments"
    },
    {
        title: "Chosen Few",
        img: chosenFew,
        spotify: "",
        apple: "",
        soundcloud: "https://soundcloud.com/spinyoungplanet/chosen-few?in=spinyoungplanet/sets/young-planet-1"
    },
    {
        title: "Glow",
        img: glow,
        spotify: "",
        apple: "",
        soundcloud: "https://soundcloud.com/spinyoungplanet/glow"
    },
    {
        title: "These Feelings",
        img: theseFeelings,
        spotify: "",
        apple: "",
        soundcloud: "https://soundcloud.com/spinyoungplanet/these-feelings"
    },
    {
        title: "11.9.16",
        img: eleven,
        spotify: "",
        apple: "",
        soundcloud: "https://soundcloud.com/spinyoungplanet/11-9-16yp"
    },
    {
        title: "Fighting Gravity",
        img: fightingGravity,
        spotify: "",
        apple: "",
        soundcloud: "https://soundcloud.com/spinyoungplanet/fighting-gravity"
    },
    {
        title: "Hardwood Classic",
        img: hardwoodClassic,
        spotify: "",
        apple: "",
        soundcloud: "https://soundcloud.com/spinyoungplanet/hardwoodclassic"
    },
    {
        title: "Point Of View",
        img: pointOfView,
        spotify: "",
        apple: "",
        soundcloud: "https://soundcloud.com/spinyoungplanet/point-of-view"
    },
]